module.exports = __webpack_public_path__ + "img/waf-c.6f5be55 1.c763d2c.svg";